// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Api from '@/api'
import Utils from '@/utils'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import './assets/css/normalize.css'
import './assets/css/basic.css'
import './assets/css/element.reset.css'
import './assets/css/animate.css'
import './assets/css/themes/orange.theme.css'
import './assets/css/font-awesome.min.css'

Date.prototype.format = function (fmt) { 
    var o = { 
        "M+" : this.getMonth() + 1,                 // 月份 
        "d+" : this.getDate(),                    // 日 
        "h+" : this.getHours(),                   // 小时 
        "m+" : this.getMinutes(),                 // 分 
        "s+" : this.getSeconds(),                 // 秒 
        "q+" : Math.floor((this.getMonth() + 3) / 3), // 季度 
        "S" : this.getMilliseconds()             // 毫秒 
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length)) 
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
        }
    }
    return fmt
}

Vue.prototype.$api = Api
Vue.prototype.$utils = Utils
// 阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false
// 事件广播对象
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()

Vue.use(ElementUI)
Vue.use(VueAxios, axios)

// 自定义组件引入
// import LyComponents from '@c/index.js'
// Vue.use(LyComponents)

// 全局路由钩子
router.beforeEach(Utils.globalRouterBeforeEach)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    methods: {
        fullTest () {
            console.log('12');
        }
    }
})
